import { styled } from "../../../../../../../../theme/default/styled";

export const SBankSelectSelectContainer = styled.div`
  position: relative;
`;
